var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.counts.length > 0)?_c('div',{staticClass:"chart",class:{open: _vm.settingsOpen}},[_c('canvas',{ref:_vm.ident,attrs:{"id":_vm.ident}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }